import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function ItemSummaryTable({ AllRows, Columns }) {
  const rows = Array.isArray(AllRows) ? AllRows : [];

  const commonCellStyle = {
    fontWeight: 400,
    fontFamily: "Quicksand",
    border: "1px solid #b6953a",
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow
              sx={{
                borderTop: "1px solid #b6953a",
              }}
            >
              {Columns.map((dt, i) => (
                <TableCell
                  key={i}
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "Quicksand",
                    border: "1px solid #b6953a",
                    backgroundColor: "#155f60",
                    borderTop: "1px solid #b6953a",
                  }}
                  align={dt.id === "name" ? "left" : "center"}
                >
                  <div className="text-[14px] whitespace-nowrap font-quicksand text-white">
                    {dt.title}
                  </div>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((Data, index) => {
              const isLastRow = index === rows.length - 1;

              return (
                <TableRow
                  key={Data._id ?? `${Data.name ?? "row"}-${index}`}
                  sx={
                    isLastRow
                      ? { backgroundColor: "#155f60", color: "#ffffff" }
                      : {}
                  }
                >
                  {Columns.map((column, i) => (
                    <TableCell
                      key={i}
                      sx={{
                        ...commonCellStyle,
                        ...(isLastRow && {
                          color: "#ffffff",
                          borderColor: "#ffffff44", // optional
                          fontWeight: "bold", // 🔥 make text bold
                        }),
                      }}
                      align="center"
                    >
                      <div
                        className={`font-quicksand maxWeb1:text-[1.5rem] maxWeb2:text-[1.8rem] maxWeb3:text-[2rem] maxWeb4:text-[2.2rem] text-[1rem] ${
                          column.id === "name" ? "text-left" : "text-center"
                        } font-poppins ${
                          (column.id === "name" || column.id === "companyId") &&
                          "whitespace-nowrap"
                        }`}
                      >
                        {["total", "amount"].includes(column.id) &&
                        typeof Data[column.id] === "number" &&
                        !Number.isNaN(Data[column.id])
                          ? new Intl.NumberFormat("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            }).format(Data[column.id])
                          : ["total", "amount", "price"].includes(column.id) &&
                            (Data[column.id] === "-" ||
                              Data[column.id] === undefined)
                          ? Data[column.id] ?? "-"
                          : ["price", "qty"].includes(column.id) &&
                            typeof Data[column.id] === "number"
                          ? new Intl.NumberFormat("en-PK", {
                              maximumFractionDigits: 2,
                            }).format(Data[column.id])
                          : Data[column.id]}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
